
export enum CustomersType
{
    Agent = 1,
    Distributor = 2,
    POS = 3
}